import React from 'react';
import useTranslation from '../hooks/useTranslation';
import Calendar from '@ingka/ssr-icon/paths/calendar-reschedule';
import styled from 'styled-components';
import { colors } from '../styles';
import Button from '@ingka/button';
import Text from '@ingka/text';
import { Slots } from '../services/Appointment/model';

interface NoTimeSlotsMessageProps {
  replacementServiceSlots: Slots[];
  serviceId: string;
  replacementServiceTitle: string;
  onReplacementServiceButtonClicked: () => void;
}

const StyledText = styled(Text)`
  &&& {
    text-align: center;
  }
`;
const StyledButton = styled(Button)`
  margin-top: 8px;
  display: block;
  margin-left: auto;
  margin-right: auto;
`;
const StyledDivider = styled.div`
  margin: 1rem 0;
  border-top: 1px solid ${colors.neutral.grey200};
`;

const NoTimeSlotsMessage: React.FC<NoTimeSlotsMessageProps> = ({
  replacementServiceSlots,
  serviceId,
  replacementServiceTitle,
  onReplacementServiceButtonClicked,
}) => {
  const { t } = useTranslation();
  if (replacementServiceSlots.length === 0) {
    return (
      <StyledText textStyle="Body.M">
        {t(`components.timePicker.noTimeslots.${serviceId}`)}
      </StyledText>
    );
  }
  return (
    <div>
      <StyledText textStyle="Body.M">
        {t(
          `components.timePicker.noTimeslots.SELECT_A_REPLACEMENT_SERVICE_ERROR`,
        )}
      </StyledText>
      <StyledDivider />
      <StyledText textStyle="HeadingRegular.L">
        {replacementServiceTitle}
      </StyledText>
      <StyledButton
        text={t(`components.timePicker.replacementServiceButtonTitle`, {
          replacementServiceTitle,
        })}
        type="emphasised"
        onClick={onReplacementServiceButtonClicked}
        ssrIcon={Calendar}
      />
    </div>
  );
};

export default NoTimeSlotsMessage;
